import * as identityConstants from "../constants/identity.constants";
import { IdentityManagementService, NewIdentityDto, IdentityDto } from '../services'
import { IIdentityEntries } from 'src/contracts/IIdentityEntries';
import { ILocalizedError, LocalizeMessage } from 'src/i18n/error-localization';
import { IRootState } from 'src/reducers';
import oauthFetch from "../helpers/oauth_fetch";

const identityEndpoint = `${process.env.REACT_APP_AUTH_ENDPOINT}`;

export const loadIdentities = () => (dispatch: any, getState: () => IRootState) => {
    const identityService = new IdentityManagementService(identityEndpoint, {fetch: oauthFetch });

    dispatch(identityRequestInitiated())
    identityService.getIdentities().then(response => {
        const identityEntries: IIdentityEntries = {
            entities: response!,
            error: null,
            isLoading: false,
        }

        dispatch(identityLoadCompleted(identityEntries))

    })
    .catch(error => {
        dispatch(identityRequestFailed(LocalizeMessage(error)))
    })
}

export const createIdentity = (identityDto: NewIdentityDto) => (dispatch: any, getState: () => IRootState) => {
    const identityService = new IdentityManagementService(identityEndpoint, {fetch: oauthFetch });

    dispatch(identityRequestInitiated())
    identityService.createIdentity(identityDto).then(response => {
        dispatch(identityCreateCompleted(response!))
    })
    .catch(error => {
        dispatch(identityRequestFailed(LocalizeMessage(error)))
    })
}

export const deleteIdentity = (id: string) => (dispatch: any, getState: () => IRootState) => {
    const identityService = new IdentityManagementService(identityEndpoint, {fetch: oauthFetch });

    dispatch(identityRequestInitiated())
    identityService.deleteIdentity(id).then(response => {
        dispatch(identityDeleteCompleted(id))
    })
    .catch(error => {
        dispatch(identityRequestFailed(LocalizeMessage(error)))
    })
}

export interface IIdentityRequest {
    type: identityConstants.IDENTITY_REQUEST;
    payload: {
        isLoading: boolean;
    };
}

export interface IIdentitiesLoadSuccess {
    type: identityConstants.IDENTITY_LOAD_SUCCESS;
    payload: IIdentityEntries;
}

export interface IIdentitiesCreateSuccess {
    type: identityConstants.IDENTITY_CREATE_SUCCESS;
    payload: IdentityDto;
}

export interface IIdentitiesDeleteSuccess {
    type: identityConstants.IDENTITY_DELETE_SUCCESS;
    payload: { id: string};
}

export interface IIdentitiesFailure {
    type: identityConstants.IDENTITY_FAILURE;
    payload: ILocalizedError;
}


export type IdentityAction = IIdentityRequest | IIdentitiesLoadSuccess | IIdentitiesFailure | IIdentitiesCreateSuccess | IIdentitiesDeleteSuccess

const identityRequestInitiated = (): IIdentityRequest => ({
    payload: { isLoading: true },
    type: identityConstants.IDENTITY_REQUEST
});

const identityLoadCompleted = (identityEntries: IIdentityEntries): IIdentitiesLoadSuccess => ({
    payload: identityEntries,
    type: identityConstants.IDENTITY_LOAD_SUCCESS
});

const identityCreateCompleted = (newIdentity: IdentityDto): IIdentitiesCreateSuccess => ({
    payload: newIdentity,
    type: identityConstants.IDENTITY_CREATE_SUCCESS
});

const identityDeleteCompleted = (id: string): IIdentitiesDeleteSuccess => ({
    payload: { id },
    type: identityConstants.IDENTITY_DELETE_SUCCESS
});

const identityRequestFailed = (error: ILocalizedError): IIdentitiesFailure => ({
    payload: error,
    type: identityConstants.IDENTITY_FAILURE
});


// WEBPACK FOOTER //
// ./src/actions/identity.actions.ts